import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from 'src/app/services/api-connection.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

declare const $: any;

@Component({
  selector: 'app-all-construction-projects',
  templateUrl: './all-construction-projects.component.html',
  styleUrls: ['./all-construction-projects.component.css'],
})
export class AllConstructionProjectsComponent implements OnInit {
  projects: any = [];
  business: any = '';
  keywords: any = '';
  city: any = '';
  price_min: any = '';
  price_max: any = '';

  hayRespuesta: boolean = false;
  activeFilter: boolean = false;

  constructor(protected apiService: ApiConnectionService) {}

  ngOnInit(): void {
    this.getAllProjects();
  }

  ngAfterViewInit(): void {
    $('.carousel').owlCarousel({
      autoHeight: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: false,
      nav: true,
      dots: false,
      loop: true,
      margin: 10,
      items: 1,
    });
  }

  getAllProjects() {
    this.apiService.getData('busqueda/projects', { auth: false }).subscribe(
      (response) => {
        this.projects = response;
        console.log(this.projects);
        this.hayRespuesta = true;
        this.activeFilter = false;
      },
      (error) => {
        Swal.fire({
          title: 'Ha ocurrido un error',
          icon: 'Error',
        }).then(() => {});
      }
    );
  }

  filtrar() {
    this.projects = [];
    this.hayRespuesta = false;
    this.activeFilter = true;

    let url =
      'busqueda/projects?withData=true&business=' +
      this.business +
      '&keywords=' +
      this.keywords +
      '&city=' +
      this.city +
      '&price_min=' +
      this.price_min +
      '&price_max=' +
      this.price_max;

    console.log(url);

    this.apiService.getData(url, { auth: false }).subscribe(
      (response) => {
        this.projects = response;
        console.log('Filtro: ', this.projects);
        this.hayRespuesta = true;
      },
      (error) => {
        Swal.fire({
          title: 'Ha ocurrido un error',
          icon: 'Error',
        }).then(() => {});
      }
    );
  }
}
